export var NotificationTimeDistributionTypes;
(function (NotificationTimeDistributionTypes) {
    NotificationTimeDistributionTypes[NotificationTimeDistributionTypes["NOTIFIABLE"] = 0] = "NOTIFIABLE";
    NotificationTimeDistributionTypes[NotificationTimeDistributionTypes["PAST"] = 1] = "PAST";
    NotificationTimeDistributionTypes[NotificationTimeDistributionTypes["FUTURE"] = 2] = "FUTURE";
    NotificationTimeDistributionTypes[NotificationTimeDistributionTypes["UNKNOWN"] = 3] = "UNKNOWN";
})(NotificationTimeDistributionTypes || (NotificationTimeDistributionTypes = {}));
//# sourceMappingURL=time-distribution.type.js.map